import { createFileRoute } from "@tanstack/react-router"
import { NamingSettingsPage } from "~/components/settings/NamingSettingsPage"

export const Route = createFileRoute("/_auth/settings/_layout/_internal/naming")({
  component: NamingSettingsPage,
})
